import { prop } from '@ipfabric/utils/fp/prop';
import type { TableMergedState } from 'components/Table/model/TableModel';
import { selectRenderedColumnWidths } from 'components/Table/model/selectors/selectRenderedColumnWidths';
import { selectVisibleColumnsByStickiness } from 'components/Table/model/selectors/selectVisibleColumnsByStickiness';
import { array } from 'fp-ts';
import { flow, pipe } from 'fp-ts/lib/function';
import { createSelector } from 'reselect';
import { sum } from 'utils/number/sum';
import { createScopedSelector } from 'utils/react/scopedSelector';

export const selectStickyColumnsWidth: (s: TableMergedState) => number =
  createScopedSelector(() =>
    createSelector(
      flow(selectVisibleColumnsByStickiness, prop('sticky')),
      selectRenderedColumnWidths,
      (stickyColumns, renderedColumnWidths) =>
        pipe(
          stickyColumns,
          array.map((column) => renderedColumnWidths[column.key] ?? 0),
          sum,
        ),
    ),
  );
